<ion-card class="HomeListCard" (click)="navigateToProperty(property.id)">
  @if (property) {
    <smartflip-property-image
      class="HomeListCard__Image"
      [useUpload]="false"
      [imgUrl]="property.imgUrl"
      [disableFullscreen]="true"
    ></smartflip-property-image>
  }

  <ion-card-content class="HomeListCard__Content">
    @if (property) {
      <span class="HomeListCard__Info"
        >{{ property.gen.address }}<br />
        {{ property.gen.city }}, {{ property.gen.state }}
        {{ property.gen.zip }}
      </span>
      <span class="fill-space"></span>

      <ion-button fill="clear" color="primary">
        <ion-icon name="chevron-forward"></ion-icon>
      </ion-button>
    } @else {
      <p [innerHTML]="noCategoryMessage"></p>
    }
  </ion-card-content>
</ion-card>
